<a
  class="templates-selector-card animate-fade-in"
  (click)="onCardClick()"
  [class.selected]="template.selected"
>
  <header>
    <i
      ngClass="{{
        template?.columns?.length > 0 ? 'cc-icon cc-icon-workflow ml-1' : 'cc-icon cc-icon-nav-bars'
      }}"
    ></i>
    <label
      (click)="preventPropagationOnClick($event)"
      class="default-label custom-control custom-checkbox select-template"
    >
      <input
        type="checkbox"
        class="custom-control-input"
        [attr.data-cy]="template.id"
        (change)="onToggleSelection()"
        [(ngModel)]="template.selected"
      />
      <span class="custom-control-indicator"></span>
    </label>
  </header>
  <main>
    <div class="template-list-card-name">{{ template.name }}</div>
    <div class="template-list-card-unique-id">{{ template.uniqueAppId }}</div>
  </main>
  <footer>
    <a class="preview-link" (click)="$event.stopPropagation(); onPreviewClick()">
      <span i18n>Preview</span>
    </a>
  </footer>
</a>
